import { TopBar } from './general_assets/topbar.js';
import { Sys_MainPage } from './systems/main_sys/main.js';
import { Sys_Banking } from './systems/banking_sys/main.js'
import './App.css';
import { Route, Routes, BrowserRouter } from 'react-router';
import rest from './utils/rest.js'
import { createRef, useState } from 'react';
import { useGlobalState } from './utils/GlobalStateProvider.js';
import { useOrientation } from 'react-use';

function App() {
  const [getGlobal, setGlobal] = useGlobalState()
  const {angle,type} = useOrientation(); 

  return (
    <div className="app">
        {!getGlobal.logged_in ? <AccessCodeScreen/> : 
          <BrowserRouter>
            <TopBar />
            <div className='main_page'>
              <Routes> 
                <Route path="/" element={<Sys_MainPage/>} />
                <Route path="/bank" element={<Sys_Banking orientation={type}/>} />
              </Routes>
            </div>
          </BrowserRouter>
        }
    </div>
  );

  function AccessCodeScreen() {
    const codeRef = createRef()
    const [loginState, setLoginState] = useState({loginClasses: ''})

    function KeyDown(event) {
      if (event.key === 'Enter') {
        SendCode()
      }
    }

    function SendCode() {
      rest.JSONRequest('auth/login', 'POST', {
        access_code: codeRef.current.value,
        device_name: 'c5_frontend'
      }).then((response) => {
        setLoginState({...loginState,
          loginClasses: response.status == 200 ? 'login_success' : 'login_failed'
        })

        if(response.status != 200) {
          setTimeout(() => {
            setLoginState({...loginState,
              loginClasses: response.status == ''
            })
          }, 1000)
          return;
        }

        setTimeout(() => {
          setGlobal({...getGlobal, logged_in: true})
        }, 1000)
      })
    }

    return (
      <div className={`login-popup ${loginState.loginClasses}`} type="error">
        <h1> Access Code Required </h1>
        <input type="password" placeholder="access_code" onKeyDown={KeyDown} ref={codeRef}/>
        <button onClick={SendCode}> submit </button>
      </div>
    )
  }
}

export default App;
